// Stay Stocked: selects the subscription option in the purchase widget instead of
// leaving the page, and brings the widget into view when a link pre-selects a plan.
(() => {
  const WIDGET = '.sls-purchase-options-container';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const whenWidgetReady = (timeout = 6000) =>
    new Promise((resolve) => {
      const found = document.querySelector(WIDGET);
      if (found) return resolve(found);
      const observer = new MutationObserver(() => {
        const widget = document.querySelector(WIDGET);
        if (widget) {
          observer.disconnect();
          resolve(widget);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => {
        observer.disconnect();
        resolve(document.querySelector(WIDGET));
      }, timeout);
    });

  const reveal = (widget) => {
    widget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // The app updates its hidden selling_plan field asynchronously, so apply the
  // choice and give it a moment to settle before trusting the result.
  const selectPlan = async (widget, planId) => {
    const select = [...widget.querySelectorAll('select')].find((s) =>
      [...s.options].some((o) => o.value === planId)
    );
    const option = select && select.closest('.sls-option-container');
    const radio = option && option.querySelector('input[type="radio"]');
    const input = widget.querySelector('[name="selling_plan"]');
    if (!select || !radio || !input) return false;

    if (!radio.checked) {
      radio.click();
      await wait(100);
    }
    for (let attempt = 0; attempt < 10; attempt++) {
      if (input.value === planId && select.value === planId) return true;
      select.value = planId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      await wait(100);
    }
    return input.value === planId;
  };

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-gs-stay-select]');
    if (!link) return;
    event.preventDefault();

    const widget = await whenWidgetReady(2000);
    if (widget && (await selectPlan(widget, link.dataset.gsStaySelect))) {
      reveal(widget);
    } else {
      // Widget missing or changed: the app pre-selects the plan from the URL instead
      window.location.href = link.href;
    }
  });

  if (new URLSearchParams(window.location.search).has('selling_plan')) {
    whenWidgetReady().then((widget) => {
      if (widget) reveal(widget);
    });
  }
})();
